import api from "./api";

export const createBooking = (data) => {
  return api.post("/bookings", data);
};
